import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    margin: '0 0 38px 20px',
    padding: '1px 32px 16px 32px',
    backgroundColor: 'secondary.main',
    boxSizing: 'border-box',
    // width: '99%',
  },
  title: {
    fontWeight: '600',
    fontSize: 22,
    color: 'common.grey850',
    mb: '32px',
  },
  mainDropdown: {
    maxWidth: 320,
  },
  subTitleContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    mb: '32px',
    mt: '28px',
  },
  subTitle: {
    fontSize: 16,
    fontWeight: '600',
    mr: '12px',
    textTransform: 'uppercase',
  },
  divider: {
    flex: 1,
  },
  fieldsContainer: {
    mr: '100px',
  },
  // KEEPS THE FIELD AT ITS 4/6 SHARE OF THE ROW, SO LONG SELECTIONS ELLIPSIZE INSTEAD OF WIDENING THE PAGE
  groupDropdown: {
    '& .MuiFilledInput-root': {
      minWidth: 0,
      maxWidth: 'calc(100% * 4 / 6)',
    },
  },
  autoCompleteContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  autoCompleteLabel: {
    display: 'flex',
    alignItems: 'center',
    flex: 2,
    marginBottom: 3,
  },
  // LONGHAND PADDING OVERRIDES THE SHORTHANDS CustomAutocomplete APPLIES
  autoComplete: {
    flex: 4,
    '& .MuiAutocomplete-inputRoot': {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: '12px',
      paddingRight: '12px',
    },
    '& .MuiAutocomplete-input': {
      paddingTop: '8px',
      paddingBottom: '8px',
      paddingLeft: 0,
      paddingRight: 0,
      fontSize: 14,
    },
  },
  autoCompleteTextField: {
    backgroundColor: 'transparent',
    '& .MuiFilledInput-root': {
      borderRadius: '4px',
      backgroundColor: 'common.lightBackgroundColor',
      '&:before': {
        borderBottom: 'none',
        content: "''",
        position: 'relative',
        border: 'none',
      },
      '&:after': {
        borderBottom: 'none',
        border: 'none',
      },
    },
  },
  readOnlyFieldContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  readOnlyFieldSpacer: {
    flex: 2,
  },
  readOnlyField: {
    flex: 4,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 2,
    mr: '100px',
  },
  emptyContainer: {
    backgroundColor: 'secondary.main',
    minHeight: '55vh',
  },
  emptyTitle: {
    color: 'footer.verticalLine',
    fontSize: 16,
    fontWeight: '700',
  },
  signatureContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    marginBottom: 2,
  },
  signatureLabelContainer: {
    flex: 2,
    color: 'grey.800',
    fontWeight: '500',
    fontSize: 14,
  },
  editorContainer: {
    flex: 4,
    overflow: 'auto',
  },
  scheduleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  scheduleLabel: {
    flex: 2,
    marginBottom: 3,
  },
  schedulePickers: {
    flex: 4,
    display: 'flex',
    alignItems: 'flex-start',
    gap: 2,
  },
  schedulePicker: {
    flex: 1,
    '& > .MuiInputLabel-root': {
      display: 'none',
    },
    '& .MuiTextField-root': {
      width: '100%',
    },
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
